import { Translation } from '../../ts/interfaces/translation.interface';

const success: Translation = {
  title: 'Success',
  subTitle: 'Everything went well.',
};

export default success;
